import { useQuery } from '@tanstack/react-query';

// Service
import { getGarageExclusionsList } from './garageExclusionsService';

export const QUERY_KEY_GARAGE_EXCLUSIONS = 'garage-exclusions';

/**
 * @description Get the list of admin users.
 * @param {object} queryParams
 * @param {number} queryParams.pageNumber
 * @param {number} queryParams.pageSize
 * @param {string|null} [queryParams.sort]
 * @param {QueriesOptions} [options] useQuery Options
 * @returns {import('@tanstack/react-query').UseQueryResult<{garageExclusions: GarageExclusion[], pagination: Pagination}, Error>}
 */
export const useGetGarageExclusionsList = (queryParams, options) => useQuery({
  queryKey: [QUERY_KEY_GARAGE_EXCLUSIONS, queryParams],
  queryFn: () => getGarageExclusionsList(queryParams),
  ...options,
});
